<template>
  <a-row type="flex" class="cloudaccount-setup-detail">
    <a-col flex="240px" class="cloudaccount-setup-col divide">
      <region-setup-list :cloudregions="cloudregions" @changeView="changeView" />
    </a-col>
    <a-col flex="auto" class="cloudaccount-setup-col">
      <component :is="view.name"  class="cloudaccount-setup-col-auto" :cloudregion="view.cloudregion" :cloudaccount="cloudaccount" @changeView="changeView" />
    </a-col>
  </a-row>
</template>

<script>
import RegionSetupList from './RegionSetupList'
import RegionSetup from './RegionSetup'

export default {
  name: 'CloudAccountSetup',
  components: {
    RegionSetupList,
    RegionSetup,
  },
  props: {
    cloudaccount: {
      type: Object,
      required: true,
    },
    cloudregions: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const view = {
      name: 'a-empty',
      cloudregion: {},
    }

    if (this.cloudregions.length > 0) {
      view.name = 'RegionSetup'
      view.cloudregion = this.cloudregions[0]
    }
    return {
      view: view,
    }
  },
  watch: {
    loading (val) {
      console.log(val, this.cloudregions.length, this.view.name)
    },
  },
  methods: {
    changeView (v) {
      this.view.name = v.name
      this.view.cloudregion = v.data
    },
  },
}
</script>

<style lang="less" scoped>
.cloudaccount-setup-detail {
  width: inherit;

  .cloudaccount-setup-col {
    height: 100%;
  }

  .cloudaccount-setup-col-auto {
    position: absolute;
    width: 100%;
  }

  .divide {
    border-right: 1px solid #e8e8e8;
  }
}
</style>
